module.exports = __webpack_public_path__ + "985c6d931437bc5288d020ad7ff0e0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/project/img/Caoua.jpg
// module id = 488
// module chunks = 0